import { PageLayout } from "@/shared/components";
import {
  EventsList,
  useEventSelectionActions,
} from "@/shared/components/events";

export function EventsPage() {
  const { selectionOptions, dialogs } = useEventSelectionActions();

  return (
    <PageLayout title="Roboto - Events" headerContentLeft="Events">
      <EventsList scope={{ type: "org" }} selectionOptions={selectionOptions} />
      {dialogs}
    </PageLayout>
  );
}
